import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SyncNotificationService {
    private onStatusChange = new Subject<any>();
    onStatusChange$ = this.onStatusChange.asObservable();
    emitChange(change: any) {
        this.onStatusChange.next(change);
    }
    
}
